import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./BookingForm.css";
import { setTime } from "../../../helpers/dateManipulators";
import { getDay } from "date-fns";
import { useTranslation } from "react-i18next";

function DateTimePicker({
  placeholder,
  label,
  disableOnDay,
  locationDetail,
  locationName,
  minDate,
  maxDate,
  onchange,
  startDate,
  endDate,
  datePickerFor,
  isSmallScreen,
}) {
  const { t } = useTranslation();
  const [date, setSelectedDate] = useState(null);
  const [enabledTimes, setEnabledTimes] = useState<Date[]>([]);
  const [isPickerOpen, setPickerOpen] = useState(false);
  const todayDateTime = () => {
    const today = new Date();
    console.log("today", today);
    today.setHours(0, 0, 0, 0);
    return today;
  };
  const handleOpenPicker = () => {
    if (!date) {
      if (datePickerFor === "pickupTime") {
        updateSelectedDate(todayDateTime());
      } else if (datePickerFor === "dropOffTime") {
        updateSelectedDate(startDate);
      }
    }
    setPickerOpen(true);
  };
  function getParentOrigin() {
    try {
      if (
        window.location.ancestorOrigins &&
        window.location.ancestorOrigins.length > 0
      ) {
        return window.location.ancestorOrigins[0];
      }
      if (document.referrer) {
        return new URL(document.referrer).origin;
      }
    } catch (error) {
      console.error("Error in getParentOrigin:", error);
      return "";
    }
  }

  const parentOrigin = getParentOrigin();
  const allowedOrigins = new Set([
    "https://mbrent.mercedes-benz.it",
    "https://bookingmerfina.mbrent.mercedes-benz.it",
    "https://mbrent.mercedes-benz.it/congaratulation",
    "https://merfinatestbooking.myrent.it",
    "https://mauroc147.myrent.it",
  ]);

  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";

  const scrollToTop = () => {
    window.parent.postMessage(
      {
        event_id: "scrollToTop",
      },
      targetOrigin
    );
  };
  const updateSelectedDate = (selectedDate) => {
    setSelectedDate(selectedDate);
    if (!selectedDate) {
      setEnabledTimes([]);
      onchange(null);
      return;
    }

    function isOpeningValid(e: any, selectedDate: Date): boolean {
      const tempSelectedDate = new Date(selectedDate);

      const validFrom = e.validFrom ? new Date(e.validFrom) : null;
      const validTo = e.validTo ? new Date(e.validTo) : null;

      const isAfterStart = !validFrom || tempSelectedDate >= validFrom;
      const isBeforeEnd = !validTo || tempSelectedDate <= validTo;

      const dayMatches = e.dayOfTheWeek % 7 === getDay(tempSelectedDate);
      const specificDayMatches = e.specificDay === formatDate(tempSelectedDate);

      return isAfterStart && isBeforeEnd && (specificDayMatches || dayMatches);
    }

    const timeSlots =
      // locationName && selectedDate
      //   ? locationDetail
      //       .find((e) => {
      //         return (
      //           e.locationName.toLowerCase() === locationName.toLowerCase()
      //         );
      //       })
      // ?.openings.filter((e) => {
      //   const tempSelectedDate = new Date(selectedDate);
      //   const validFrom = new Date(e?.validFrom);
      //   const validTo = new Date(e?.validTo);

      //   return (
      //     (!e?.validFrom || tempSelectedDate >= validFrom) &&
      //     (!e?.validTo || tempSelectedDate <= validTo) &&
      //     (e.specificDay === formatDate(tempSelectedDate) ||
      //       e.dayOfTheWeek % 7 === getDay(tempSelectedDate))
      //   );
      // })
      // .map((e) => ({
      //   start: setTime(
      //     datePickerFor === "pickupTime" ? e.startTime : e.startTime,
      //     selectedDate
      //   ),
      //   end: setTime(
      //     datePickerFor === "pickupTime" ? e.endTime : e.endTime,
      //     selectedDate
      //   ),
      // }))?.[0]
      //   : [];
      locationName && selectedDate
        ? locationDetail
            .find((e) => {
              return (
                e.locationName.toLowerCase() === locationName.toLowerCase()
              );
            })
            ?.openings?.filter((e) => isOpeningValid(e, selectedDate))
            .map((e) => ({
              start: setTime(e.startTime, selectedDate),
              end: setTime(e.endTime, selectedDate),
            }))?.[0]
        : [];

    if (timeSlots && timeSlots.start && timeSlots.end) {
      const times = getTimeIntervals(timeSlots.start, timeSlots.end);
      setEnabledTimes(times);

      if (
        times.length > 0 &&
        !selectedDate.getHours() &&
        !selectedDate.getMinutes()
      ) {
        setSelectedDate(times[0]);
        onchange(times[0]);
        setPickerOpen(false);
      } else {
        onchange(selectedDate);
        setPickerOpen(false);
      }
    } else {
      setEnabledTimes([]);
      onchange(selectedDate);
      //setPickerOpen(false);
    }
  };

  const getDatesInRange = (start, end) => {
    const dateArray = [];
    const currentDate = new Date(start);
    const endDate = new Date(end);
    while (currentDate <= endDate) {
      dateArray.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dateArray;
  };

  const formatDate = (date) => {
    const currentTime = new Date();
    const d = new Date(date);
    d.setHours(currentTime.getHours());
    d.setMinutes(currentTime.getMinutes());
    d.setSeconds(currentTime.getSeconds());
    d.setMilliseconds(currentTime.getMilliseconds());
    return d.toISOString().split("T")[0];
  };

  const getTimeIntervals = (start, end) => {
    const intervals: Date[] = [];
    const currentTime = new Date(start);
    while (currentTime <= end) {
      intervals.push(new Date(currentTime));
      currentTime.setMinutes(currentTime.getMinutes() + 30);
    }
    return intervals;
  };

  const isDateDisabled = (date) => {
    const dayOfWeek = date.getDay();
    return !disableOnDay.includes(dayOfWeek);
  };
  return (
    <div className="datetime-picker-card">
      <label
        className="dateTimelabel"
        style={{ fontFamily: "MBCorpoAScreen1Cond-Regular-Web" }}
      >
        {label}
      </label>
      {!isSmallScreen ? (
        <DatePicker
          selected={date}
          onFocus={scrollToTop}
          // onCalendarOpen={scrollToTop}
          onCalendarOpen={() => {
            scrollToTop();
            if (!date) {
              if (datePickerFor === "pickupTime") {
                updateSelectedDate(todayDateTime());
              } else if (datePickerFor === "dropOffTime") {
                updateSelectedDate(startDate);
              }
            }
          }}
          onChange={(date) => updateSelectedDate(date)}
          showTimeSelect
          dateFormat="MMMM d, yyyy HH:mm"
          timeCaption={t("Select time")}
          className="date-picker-input"
          placeholderText={placeholder}
          filterDate={isDateDisabled}
          includeTimes={enabledTimes.length > 0 ? enabledTimes : undefined}
          minDate={minDate}
          maxDate={maxDate}
          highlightDates={getDatesInRange(startDate, endDate)}
          locale="it"
        />
      ) : (
        <>
          <div
            className="custom-date-picker"
            onClick={handleOpenPicker}
            style={{
              height: "63px",
              width: "320px",
              border: "1px solid #ccc",
              padding: "10px",
              borderRadius: "4px",
              cursor: "pointer",
              backgroundColor: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              fontFamily: "MBCorpoSText-CondRegular-Web",
            }}
          >
            <span>{date ? date.toLocaleString() : placeholder}</span>
          </div>
          <DatePicker
            className="hidden"
            style={{ display: "none", position: "absolute", top: "-1000px" }}
            selected={date || startDate}
            onChange={(date) => updateSelectedDate(date || startDate)}
            showTimeSelect
            dateFormat="MMMM d, yyyy HH:mm"
            timeCaption={t("Select time")}
            placeholderText={placeholder}
            filterDate={isDateDisabled}
            includeTimes={enabledTimes.length > 0 ? enabledTimes : undefined}
            minDate={minDate}
            maxDate={maxDate}
            highlightDates={getDatesInRange(startDate, endDate)}
            locale="it"
            open={isPickerOpen}
            onClickOutside={() => setPickerOpen(false)}
          />
        </>
      )}
    </div>
  );
}

export default DateTimePicker;
